export enum ArtifactFileUploadStatus {
  NoFile = "NoFile",
  FileUploaded = "FileUploaded",
}

export enum ArtifactType {
  ProjectDatabase = "ProjectDatabase",
  SystemProgramming = "SYSTEM_PROGRAMMING",
}

export enum ArtifactProjectType {
  HW = "HW",
  RA = "RA",
  Athena = "Athena",
  LDPlus = "LDPlus",
}

export enum LutronDesignerMessageType {
  GetLocalArtifactsRequest = "GetLocalArtifactsRequest",
  GetLocalArtifactsResult = "GetLocalArtifactsResult",
  OpenArtifactRequest = "OpenArtifactRequest",
  CreateArtifactRequest = "CreateArtifactRequest",
  OpenLocalRequest = "OpenLocalRequest",
  OpenVersionRequest = "OpenVersionRequest",
  MigrateToAthenaRequest = "MigrateToAthenaRequest",
}

export const ArtifactProjectTypeLabel: {
  [key: string]: string;
} = {
  [ArtifactProjectType.HW]: "HW",
  [ArtifactProjectType.RA]: "RA",
  [ArtifactProjectType.Athena]: "Q",
  [ArtifactProjectType.LDPlus]: "LD+",
};

export interface Artifact {
  associatedWith: string | null;
  artifactBlobReference: string | null;
  artifactType: ArtifactType | null;
  placeId: string; // UUID
  fileUploadStatus: ArtifactFileUploadStatus;
  contentMD5Hash: string | null;
  owner: string | null;
  etag: string | null;
  artifactTags: Record<string, string> | null;
  additionalAttributes: Record<string, string> | null;
  id: string; // UUID
  href: string;
  name: string | null;
  createdDate: string | null; // Date String
  modifiedDate: string; // Date String
  description: string | null;
  tags: string[] | null;
  createdBy: string | null;
  modifiedBy: string | null;
  artifactProjectType: string | null;
}

export interface Version {
  versionId: string;
  eTag: string | null;
  lastModified: string;
  modifiedBy: string | null;
  versionHref: string;
  artifactTags: Record<string, string> | null;
}

export interface VersionData {
  items: Version[] | null;
  continuationToken?: string | null;
}
